import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import 'animate.css';
import 'weui';
import 'react-weui/build/packages/react-weui.css';
import {Provider,observer} from 'mobx-react';
import {useStrict} from 'mobx';
import RootStore from './store/RootStore';
import './default/env';

import Main from './main';
import registerServiceWorker from './registerServiceWorker';


useStrict(true);

@observer
class Index extends React.Component{
    render(){
        return (
            <Provider rootStore={new RootStore()}>
                <Main/>
            </Provider>
        )
    }
}

ReactDOM.render(<Index />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js